import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Survey_Content_Response } from "@/interfaces/api/survey/api_response_types"
import { getSurveyContent } from "../requests/survey"

type surveyContentOptions = Omit<
  UseQueryOptions<API_Data_Survey_Content_Response, API_Error, API_Data_Survey_Content_Response, ['exitSurveyContent', string]>,
  'queryKey' | 'queryFn'
>

export const useSurveyContent = (endpoint: string, options?: surveyContentOptions) => 
  useQuery<API_Data_Survey_Content_Response, API_Error, API_Data_Survey_Content_Response, ['exitSurveyContent', string]>({
    queryKey: ['exitSurveyContent', endpoint],
    retry: false,
    queryFn: () => getSurveyContent(endpoint),
    ...options
  })